export const deepRemoveKeys = <T>(object: T, keyToRemove: string): T =>
  JSON.parse(JSON.stringify(object), omitKey.bind(this, keyToRemove));

const omitKey = <T>(keyToRemove: string, key: string, value: T) =>
  key === keyToRemove ? undefined : value;
